export default "__VITE_ASSET__uNmH6xop__"